<template>
  <ol class="breadcrumb">
    <li v-for="(item, index) in list" :key="item.path" class="breadcrumb-item">
      <span v-if="isLast(index)" class="active">{{ showName(item) }}</span>
      <router-link v-else :to="item.path">{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    separator: {
      type: String,
      default: '',
    },
  },

  methods: {
    isLast(index) {
      return index === this.list.length - 1;
    },
    showName(item) {
      let newVal = item;
      if (newVal.meta && newVal.meta.label) {
        newVal = newVal.meta && newVal.meta.label;
      }
      if (newVal.name) {
        newVal = newVal.name;
      }
      return newVal;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?23767438